import { z } from 'zod';

export const mediaInfoSchema = z.object({
  id: z.number(),
  uuid: z.string().optional().nullable(),
  uri: z.string().url(),
  thumbnail_url: z.string().url(),
  preview_url: z.string().url(),
  name: z.string(),
  size: z.number(),
  mime_type: z.string(),
  isTemporary: z.boolean().optional(),
  deleted: z.boolean().optional().nullable(),
});
